import { createContext, useContext } from 'react';
import { GitlabInstallationContextValue } from './types';

export const GitlabInstallationContext = createContext<
  GitlabInstallationContextValue | undefined
>(undefined);

/**
 * Hook to access the GitLab installation context.
 *
 * Provides access to the organization URL state for the GitHub app installation flow.
 *
 * @returns The GitLab installation context value
 *
 * @throws Error if used outside GitlabInstallationContext.Provider
 */
export const useGitlabInstallation = () => {
  const context = useContext(GitlabInstallationContext);

  if (!context) {
    throw new Error(
      'useGitlabInstallation must be used within GitlabInstallationContext.Provider',
    );
  }

  return context;
};
